import {
  IrequestCategoriesTree,
  IreceiveCategoriesTreeError,
  IreceiveCategoriesTreeSuccess,
  CategoriesTree,
  IrequestSubcategoriesTree,
  IreceiveSubcategoriesTreeSuccess,
  SubcategoriesTree,
  IrereceiveSubcategoriesTreeError,
} from './types';
import { langSelector } from '../App/selectors';
import { productCategoriesSelector } from './selectors';
import { arrayMove } from './utilities';

export const namespace = 'Header';

const requestCategoriesTree = (): IrequestCategoriesTree => ({
  type: 'Header/REQUEST_CATEGORIES',
});

const receiveCategoriesTreeSuccess = (
  categories: CategoriesTree,
): IreceiveCategoriesTreeSuccess => ({
  type: 'Header/RECEIVE_CATEGORIES_SUCCESS',
  payload: {
    categories,
  },
});

const receiveCategoriesTreeError = (error): IreceiveCategoriesTreeError => ({
  type: 'Header/RECEIVE_CATEGORIES_ERROR',
  payload: {
    error,
  },
});

export const loadCategoriesTree = () => {
  return async (dispatch, getState, API) => {
    try {
      if (!getState().header.categories.productCategories) {
        dispatch(requestCategoriesTree());
        const categories = await API.loadTree();

        const filteredCategories = categories.filter(el => {
          return (
            el.category_name_ans !== '_NEZARADENE' &&
            el.category_name_ans !== 'Prepravné' &&
            el.category_name_ans !== 'NEZOBRAZUJE SA'
          );
        });

        let index = filteredCategories
          .map(e => e.category_name_ans)
          .indexOf('Darčeková poukážka');
        let sortedCategories = arrayMove(
          filteredCategories,
          index,
          filteredCategories.length - 1,
        );

        index = sortedCategories
          .map(e => e.category_name_ans)
          .indexOf('Výpredaj');
        sortedCategories = arrayMove(
          sortedCategories,
          index,
          sortedCategories.length - 1,
        );

        index = sortedCategories
          .map(e => e.category_name_ans)
          .indexOf('Pletacia vlna a priadza');
        sortedCategories = arrayMove(sortedCategories, index, 0);

        index = sortedCategories.map(e => e.category_name_ans).indexOf('Látky');
        sortedCategories = arrayMove(sortedCategories, index, 1);

        index = sortedCategories
          .map(e => e.category_name_ans)
          .indexOf('Macrame a textilná priadza');
        sortedCategories = arrayMove(sortedCategories, index, 2);

        dispatch(receiveCategoriesTreeSuccess(sortedCategories));

        // load homepage products
        if (sortedCategories && sortedCategories[0]) {
          const id = sortedCategories[0].category_id;
          return id;
        }
      } else {
        return productCategoriesSelector(getState())[0].category_id;
      }
    } catch (e) {
      console.log({ e });
      dispatch(receiveCategoriesTreeError(e));
    }
  };
};

const requestSubcategoriesTree = (
  parentCategoryId: number,
): IrequestSubcategoriesTree => ({
  type: 'Header/REQUEST_SUBCATEGORIES',
  payload: {
    parentCategoryId,
  },
});

const receiveSubcatergoriesTreeSuccess = (
  subcategoriesTree: SubcategoriesTree,
  parentCategoryId: number,
): IreceiveSubcategoriesTreeSuccess => ({
  type: 'Header/RECEIVE_SUBCATEGORIES_SUCCESS',
  payload: {
    subcatgories: subcategoriesTree,
    parentCategoryId,
  },
});

const receiveSubcatergoriesTreeError = (
  error: any,
): IrereceiveSubcategoriesTreeError => ({
  type: 'Header/RECEIVE_SUBCATEGORIES_ERROR',
  payload: {
    error,
  },
});

export const loadSubcategoriesTree = (categoryId: number) => {
  return async (dispatch, getState, API) => {
    try {
      const lang = langSelector(getState());
      dispatch(requestSubcategoriesTree(categoryId));
      const subcategoriesTree: SubcategoriesTree = await API.loadSubTree(
        categoryId,
        {},
        { xAcceptLanguage: lang },
      );
      dispatch(receiveSubcatergoriesTreeSuccess(subcategoriesTree, categoryId));
    } catch (e) {
      dispatch(receiveSubcatergoriesTreeError(e));
    }
  };
};

export const changeDimmerVisibility = (newValue: boolean) => ({
  type: 'Header/CHANGE_TOGGLE_VISIBLE',
  payload: {
    newValue,
  },
});

// const requestSearchTerm = (searchTerm: string): IrequestSearchTerm => ({
//   type: 'Header/REQUEST_SEARCH_TERM',
//   payload: {
//     searchTerm,
//   },
// });

// const receiveSearchTermResultsSuccess = (
//   searchTerm,
//   articles,
// ): IreceiveSearchTermResultSuccess => ({
//   type: 'Header/RECEIVE_SEARCH_TERM_SUCCESS',
//   payload: {
//     articles,
//     searchTerm,
//   },
// });

// export const loadSearchTermResults = (
//   searchTerm: string,
//   limit: number = 5,
//   offset: number = 0,
//   sort: string = '',
//   sortDir: string = '',
// ) => {
//   return async (dispatch, getState, API) => {
//     try {
//       dispatch(requestSearchTerm(searchTerm));
//       // const lang: string = langSelector(getState());
//       // const currency: string = currencySelector(getState());
//       const articlesResult = await API.loadArticles({
//         sitemapId: 135,
//       });

//       dispatch(receiveSearchTermResultsSuccess(searchTerm, articlesResult));
//     } catch (e) {
//       console.error(e);
//     }
//   };
// };
